<template>
   <img v-if="src && !hasError" :src :alt @error="hasError = true" />
   <div v-else class="bg-light-grey flex size-full items-center justify-center">
      <Icon name="logo-mono" class="text-grey size-[60%]" />
   </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

type Props = {
   src?: string | null
   alt?: string
}

const props = withDefaults(defineProps<Props>(), {})
const hasError = ref(false)
</script>
